export const myLibraryModalText = {
  title: 'My Library',
  allFiles: 'All files',
  allImages: 'All images',
  allVideos: 'All videos',
  vimeoVideos: 'Vimeo Videos',
};
